(function () {

  function setSparkProductCardStyles() {
    var hosts = document.querySelectorAll('spark-product-card'); // replace with actual host
    hosts.forEach(function (host) {
      setTimeout(function () {
        setShadowStyles(host, `
        .product-rrp-price {
          text-decoration: line-through!important;
        }
        .product-rrp-price :first-child {
          display: none !important;
        }`);
        updatePriceText(host);
      }, 1000); // wait for host to be available
    });
  }

  // Wait for DOMContentLoaded to ensure the hosts are present
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setSparkProductCardStyles);
  } else {
    setSparkProductCardStyles();
  }

  function setShadowStyles(host, css) {
    if (!host) {
      console.warn('setShadowStyles: host is not provided');
      return;
    }

    // Ensure we have a shadow root. If host can't have one, bail out.
    var root = host.shadowRoot || (host.attachShadow ? host.attachShadow({mode: 'open'}) : null);
    if (!root) {
      console.warn('setShadowStyles: no shadowRoot and cannot attach one on host', host);
      return;
    }

    // Prefer constructible stylesheet (faster, scoped) when supported
    var supportsConstructible = typeof CSSStyleSheet !== 'undefined' &&
      'replaceSync' in CSSStyleSheet.prototype &&
      'adoptedStyleSheets' in root;

    if (supportsConstructible) {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      // Preserve any existing adopted sheets
      root.adoptedStyleSheets = (root.adoptedStyleSheets || []).concat(sheet);
    } else {
      // Fallback: create a <style> inside the shadowRoot
      var style = document.createElement('style');
      style.textContent = css;
      // Prepend so it has higher precedence than later injected rules
      root.prepend(style);
    }
  }

  function updatePriceText(host) {
    var root = host.shadowRoot;
    if (!root) return;
    var rrpPriceElem = root.querySelector('.product-rrp-price');
    if (rrpPriceElem) {
      let arr = rrpPriceElem.textContent.split(':')
      if (arr.length > 1) {
        rrpPriceElem.textContent = arr[1].trim();
      }
    } else {
      setTimeout(function () {
        updatePriceText(host);
      }, 50);
    }
  }
})();